export const PENDING_PROMPT_EVENT = 'ask-singular-ai:pending-prompt';

// Attribution is time-based: on a same-page handoff the router's page-load listener fires after the prompt was consumed.
const RECENT_HANDOFF_MS = 5000;

let pendingHandoff = null;
let lastHandoffAt = 0;

export const setPendingPrompt = (prompt, { usedVoice = false } = {}) => {
    const isValid = typeof prompt === 'string' && prompt.length > 0;
    pendingHandoff = isValid ? { prompt, usedVoice } : null;
    if (!isValid) return;
    lastHandoffAt = Date.now();
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(PENDING_PROMPT_EVENT));
    }
};

export const takePendingPrompt = () => {
    const value = pendingHandoff;
    pendingHandoff = null;
    return value;
};

export const wasRecentHandoff = () => lastHandoffAt !== 0 && Date.now() - lastHandoffAt < RECENT_HANDOFF_MS;

export const clearPendingPrompt = () => {
    pendingHandoff = null;
    lastHandoffAt = 0;
};
